import {
    Fragment,
    useEffect,
    useState
} from "react";
import {
    LITIGATORS_API_ENDPOINT,
    LITIGATORS_API_USER,
    LITIGATORS_API_PASSWORD,
} from "../Constants";

function Litigators({
    prefixLabel = "Litigators DB Suggests: ",
    phoneNumber,
    fakeBlackList = false,
    fakeDncScrub = false,
    onResultUpdate
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState("");
    const [finalResult, setFinalResult] = useState({ status: "", message: "Loading, Please Wait!" });

    function getLitigatorsResponseMessage(response) {
        if ("match" in response?.data) {
            let result = response?.data?.match[phoneNumber];
            if (result) {
                let type = result.type;
                let status = result.status;

                return {
                    status: 'found',
                    message: `${phoneNumber} Found : (${type ? type : status})`
                };
            } else {
                return {
                    status: 'safe',
                    message: `${phoneNumber} is Clean`
                };
            }
        } else {
            if ("clean" in response.data) {
                return {
                    status: 'safe',
                    message: `${phoneNumber} is Clean`
                };
            } else {
                return {
                    message: `ERROR! ${response.data.message}`
                };
            }
        }
    }

    const getDncResponseMessage = (response) => {
        if ("match" in response.data) {
            const result = response.data.match[phoneNumber];
            if (result) {
                const { type } = result;
                return processResponseMessageForDnc(type);
            }
        }
        if ("clean" in response.data) {
            return {
                status: 'safe',
                message: `${phoneNumber} : Clean`
            };
        } else {
            return {
                message: `ERROR: ${response.data.message}`
            };
        }
    };

    function processResponseMessageForDnc(type) {
        if (type.includes("TCPA troll") || type.includes("DNC Complainers")) {
            return {
                status: 'found',
                message: `${phoneNumber} Found : TCPA`
            };
        } else if (type.includes("Federal DNC")) {
            return {
                status: 'found',
                message: `${phoneNumber} Found : DO NOT CALL`
            };
        } else {
            return {
                status: 'safe',
                message: `${phoneNumber} Found : Clean`
            };
        }
    }

    function getBlackListResponseMessage(response) {
        if (!response) {
            return;
        }
        if ("match" in response?.data) {
            let result = response?.data?.match[phoneNumber];
            if (result) {
                let type = result.type;
                // let status = result.status;

                if (type && type.includes("Federal DNC")) {
                    return {
                        status: 'found',
                        message: `${phoneNumber} Found : DNC`
                    };
                } else {
                    return {
                        status: 'found',
                        message: `${phoneNumber} Found : BLACKLISTED`
                    };
                }
            }
        }
        return {
            status: 'safe',
            message: `${phoneNumber} Found : Clean`
        };
    }

    async function fetchData() {
        setIsLoading(true);
        const axios = require("axios").default;
        try {
            const response = await axios.post(
                LITIGATORS_API_ENDPOINT, {
                    phone_number: phoneNumber,
                    type: "all",
                }, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    auth: {
                        username: LITIGATORS_API_USER,
                        password: LITIGATORS_API_PASSWORD,
                    },
                }
            );

            setResponse(response);
        } catch (error) {
            setError(`Error : ${JSON.stringify(error.data)} `);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        // When phone number changes, reset states and start fetching
        setIsLoading(true);
        setResponse(null);
        setError("");
        setFinalResult({ status: "", message: "Loading, Please Wait!" });
        
        // Explicitly notify parent about loading state
        if (onResultUpdate) {
            onResultUpdate({ 
                status: "", 
                message: "Loading, Please Wait!" 
            });
        }
        
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phoneNumber]);

    useEffect(() => {
        if (!isLoading) {
            const result = getFinalMessage(fakeBlackList, fakeDncScrub);
            setFinalResult(result);
            
            if (onResultUpdate) {
                onResultUpdate(result);
            }
        }
    }, [isLoading, error, response, fakeBlackList, fakeDncScrub]);

    function getFinalMessage(fakeBlackList, fakeDncScrub) {
        if (isLoading) {
            return { status: "", message: `Loading, Please Wait!` };
        }
        if (error) {
            return { status: "", message: error };
        }
        if (!response?.data) {
            return { status: "", message: " " };
        }
        if (response && fakeBlackList) {
            return getBlackListResponseMessage(response);
        }
        if (response && fakeDncScrub) {
            return getDncResponseMessage(response);
        }
        return getLitigatorsResponseMessage(response);
    }

    function renderResult(label, result, index) {
        return (
            <div 
                key={index}
                style={{ 
                    margin: '5px 0', 
                    textAlign: 'center', 
                    lineHeight: '1.5',
                    padding: '10px',
                    borderRadius: '4px',
                    fontWeight: '700',
                    background: isLoading ? '#f9f9f9' : 
                               result.status === 'safe' ? '#ebfaeb' : 
                               result.status === 'found' ? '#ffebeb' : '#ffffff',
                    border: isLoading ? '1px solid #f0f0f0' : 
                            result.status === 'safe' ? '1px solid #c3e6cb' : 
                            result.status === 'found' ? '1px solid #f5c6cb' : '1px solid #f0f0f0'
                }}
            >
                <span style={{ 
                    color: '#e63946', 
                    fontWeight: 'bold'
                }}>
                    {label}
                </span>
                {isLoading ? 
                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <div className="loader loader-small" style={{ marginRight: '8px' }}></div> Loading...
                    </span> : 
                    <span style={{ 
                        color: result.status === 'safe' ? '#28a745' : 
                              result.status === 'found' ? '#dc3545' : '#000000'
                    }}>
                        {result.message}
                    </span>
                }
            </div>
        );
    }

    return renderResult(prefixLabel, finalResult, 0);
}

export default Litigators;